module.exports = __webpack_public_path__ + "img/xyzp.ebc877fc.png";